import { cn } from "@/shared/libs/commonUtils";
import type { HTMLAttributes, Ref } from "react";
import { useCarousel } from "./CarouselContext";

interface ICarouselContentProps extends HTMLAttributes<HTMLDivElement> {
  innerRef?: Ref<HTMLDivElement>;
}

export default function CarouselContent({
  innerRef,
  className,
  ...props
}: ICarouselContentProps) {
  const { carouselRef, orientation } = useCarousel();
  return (
    <div ref={carouselRef} className="overflow-hidden">
      <div
        ref={innerRef}
        className={cn(
          "flex",
          orientation === "horizontal" ? "-ml-4" : "-mt-4 flex-col",
          className,
        )}
        {...props}
      />
    </div>
  );
}
